import { useEffect } from 'react';

import {getCurrentLayout} from "../../../appLayout";
import sqftShapeManager from "../../components/canvas/store/sqftShapeManager";
import {isSFTCabinetsGroup} from "../../helpers/sqftNavigationHelper";

const useUpdateCabinetFeatures = () => {

  useEffect (() => {
    const layout = getCurrentLayout();
    if (isSFTCabinetsGroup() && layout.parts.Cabinet) {
      if (layout.parts.Cabinet.topCabinet) {
        const topCabinetFeature = layout.parts.Cabinet.topCabinet.activeFeature;
        sqftShapeManager.changeShapesFeatureIDIfColorWasChanged(topCabinetFeature);
      }
      if (layout.parts.Cabinet.bottomCabinet) {
        const bottomCabinetFeature = layout.parts.Cabinet.bottomCabinet.activeFeature;
        sqftShapeManager.changeShapesFeatureIDIfColorWasChanged(bottomCabinetFeature);
      }
    }
  }, []);
};

export default useUpdateCabinetFeatures;
